module.exports = __webpack_public_path__ + "img/dentArtistry.d9df2f51.svg";